import { Component } from '@angular/core';

@Component({
  selector: 'app-giving-day-banner',
  templateUrl: './giving-day-banner.component.html',
  styleUrl: './giving-day-banner.component.css',
  standalone: false
})

export class GivingDayBannerComponent {
  isGivingDay(): boolean {
    const today = new Date();
    const givingDay = new Date(2025, 3, 30);
    return today.getDate() === givingDay.getDate() && today.getMonth() === givingDay.getMonth() && today.getFullYear() === givingDay.getFullYear();

  }

}
